import moment from "moment";
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import TaskPreview from "../../../Components/TaskPreview";
import TaskPreviewDot from "../../../Components/TaskPreviewDot";
import TaskTimeslotContainer from "../../../Components/TaskTimeslotContainer";

export default function Day({
  offset,
  tasks,
  clickDot,
  setComplete,
  addNewTask,
}) {
  const inputRef = useRef();
  const date = moment().subtract(moment().day(), "days").add(offset, "days");
  const allTasks = useSelector((state) =>
    state.tasks.filter((t) => !t.complete && moment(t.date).isSame(date, "day"))
  );
  const scheduled = tasks.filter((t) => moment(t.date).isSame(date, "day"));
  const [input, setInput] = useState("");
  const [showInput, setShowInput] = useState(false);
  const getBackgroundColor = () => {
    if (date.isSame(moment(), "day")) {
      return "#d9e7ff";
    } else if (date.isBefore(moment())) {
      return "#888";
    }
    return "#ccc";
  };
  const submitNewTimeslot = () => {
    if (input.length > 0) {
      addNewTask(input, tasks.length, date.toISOString());
    }
    closeNewTimeslot();
  };
  const addNewTimeslot = () => {
    setShowInput(true);
    if (
      inputRef.current &&
      typeof inputRef.current.getInputDOMNode === "function"
    ) {
      inputRef.current.getInputDOMNode().focus();
    }
  };
  const closeNewTimeslot = () => {
    setInput("");
    setShowInput(false);
  };

  return (
    <td
      style={{ backgroundColor: getBackgroundColor() }}
      onClick={() => addNewTimeslot()}
    >
      <div style={{ height: "100%", display: "flex", flexFlow: "column" }}>
        <div style={{ display: "flex" }}>
          <div style={{ fontSize: "18px", paddingLeft: "3px" }}>
            {date.format("D")}
          </div>
          {allTasks.map((t) => (
            <TaskPreviewDot
              task={t}
              showDate={false}
              onClick={(t) => clickDot(t, tasks.length)}
            />
          ))}
        </div>

        <TaskTimeslotContainer
          tasks={scheduled}
          date={date}
          setComplete={setComplete}
        />
        {showInput && (
          <input
            ref={inputRef}
            type="text"
            autoFocus
            value={input}
            onKeyPress={(e) => {
              if (e.code === "Enter") {
                submitNewTimeslot();
              }
            }}
            onBlur={() => closeNewTimeslot()}
            onChange={(e) => setInput(e.target.value)}
            style={{ width: "90%" }}
          />
        )}
      </div>
    </td>
  );
}
